import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnDestroy,
    Output,
    ViewChild
} from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { combineLatest, of } from 'rxjs'
import { map } from 'rxjs/operators'
import { UnsubscribeOnDestroy } from '../../../../../utility'
import { SearchListing } from '../../../../../../graphql'
import { GoogleMapsService } from '../../../../../injectable/google-maps-service'

@Component({
    selector: 'app-map-marker',
    templateUrl: './map-marker.html',
    styleUrls: ['map-marker.scss']
})
export class MapMarkerComponent extends UnsubscribeOnDestroy implements AfterViewInit, OnDestroy {
    @Input() map: google.maps.Map
    @Input() listing: SearchListing
    @Input() hoveredListingId$ = new BehaviorSubject<string>('')
    @Input() infoWindowListingId$ = of('')
    @Input() index: number = 90

    private marker: google.maps.marker.AdvancedMarkerElement
    selected$ = of(false)

    @Output() clicked = new EventEmitter<google.maps.marker.AdvancedMarkerElement>()
    @Output() initializeClusterer = new EventEmitter()

    @ViewChild('priceTagRef') priceTag !: ElementRef

    constructor(
        private _cdRef: ChangeDetectorRef,
        private _googleMapsService: GoogleMapsService
    ) {
        super()
    }

    ngAfterViewInit(): void {
        this.selected$ = combineLatest([this.hoveredListingId$, this.infoWindowListingId$])
            .pipe(map(([hoverId, infoId]) => hoverId === this.listing.listingId || infoId === this.listing.listingId
        ))

        this.placeMarker()

        const sub = this.selected$
            .subscribe(selected => {
                if (selected) {
                    this.marker.zIndex = Number(google.maps.Marker.MAX_ZINDEX) * 2 
                    this._googleMapsService.activeMarker = this.marker
                } else {
                    this.marker.zIndex = 99 - this.index
                }
            })

        this._subscriptions.push(sub)
        
        this._subscriptions.push(
            this.selected$.subscribe((selected) => {
                if (selected === undefined) { 
                    return 
                }
                this._cdRef.detectChanges()
            }))
    }

    ngOnDestroy(): void {
        super.ngOnDestroy()
        if (!this?.marker?.map) { return }
        // @ts-ignore
        this?.marker?.map = null
        this._googleMapsService.activeMarker = null
    }

    private placeMarker() {
        if (!this.map || !this.listing) { return }
        const marker = new google.maps.marker.AdvancedMarkerElement({
            map: this.map,
            position: { lat: this.listing.obfuscatedLocation.location.lat, lng: this.listing.obfuscatedLocation.location.lng },
            content: this.priceTag.nativeElement
        })

        marker.addListener('click', () => {
            this.onClick()
        })

        this.marker = marker
        this._googleMapsService.markers.push(marker)
    }

    onClick() {
        this.hoveredListingId$.next('')
        this.clicked.next(this.marker)
    }

    focusListing(id: string) {
        this.hoveredListingId$.next(id)
        this._cdRef.detectChanges()
    }
}
